import Axios from 'axios'

export function removeToken() {
  localStorage.removeItem('token')
  sessionStorage.removeItem('token')
}

export function getToken() {
  const tokenString = localStorage.getItem('token')
  if (tokenString) {
    const { token, expireTime } = JSON.parse(tokenString)
    const now = new Date().getTime()
    if (expireTime >= now) {
      return token
    } else {
      removeToken()
      return null
    }
  } else {
    const tempToken = sessionStorage.getItem('token')
    if (tempToken) {
      return tempToken
    } else {
      removeToken()
      return null
    }
  }
}

export function setToken(token: string, remember: boolean) {
  if (remember) {
    removeToken()
    const expireTime = new Date().getTime() + 604800000
    localStorage.setItem('token', JSON.stringify({ token, expireTime }))
  } else {
    removeToken()
    sessionStorage.setItem('token', token)
  }
}

export function removeSchoolInfo() {
  localStorage.removeItem('schoolInfo')
}

export function getSchoolInfo() {
  const schoolInfo = localStorage.getItem('schoolInfo')
  if (schoolInfo) {
    return JSON.parse(schoolInfo)
  } else {
    return null
  }
}

export function setSchoolInfo(schoolInfo) {
  removeSchoolInfo()
  localStorage.setItem('schoolInfo', JSON.stringify(schoolInfo))
}

export function removeRoleType() {
  localStorage.removeItem('roleType')
}

export function getRoleType() {
  return localStorage.getItem('roleType') || ''
}

export function setRoleType(roleType: string) {
  removeRoleType()
  localStorage.setItem('roleType', roleType)
}

export function removeSectionTeacher() {
  localStorage.removeItem('sectionTeacher')
}

export function getSectionTeacher() {
  return localStorage.getItem('sectionTeacher') === 'true' ? true : false
}

export function setSectionTeacher(sectionTeacher: boolean) {
  removeSectionTeacher()
  localStorage.setItem('sectionTeacher', sectionTeacher.toString())
}

export function getLocale() {
  return localStorage.getItem('locale') || 'en'
}

export function setLocale(locale: string) {
  return localStorage.setItem('locale', locale)
}

export function getFile(url) {
  return new Promise((resolve, reject) => {
    Axios({ method: 'get', url, responseType: 'arraybuffer' })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.toString())
      })
  })
}

export function removeUserInfo() {
  localStorage.removeItem('userInfo')
}

export function getUserInfo() {
  const userInfo = localStorage.getItem('userInfo')
  if (userInfo) {
    return JSON.parse(userInfo)
  }
  return {}
}

export function setUserInfo(userInfo: string) {
  removeUserInfo()
  localStorage.setItem('userInfo', userInfo)
}
